
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.89 22.535a2.584 2.584 0 000 3.653h.187l9.999-9.997V16L11.079 6h-.19a2.58 2.58 0 000 3.649l6.443 6.442-6.44 6.444h-.001z","fill":"#0072C8","fill-rule":"evenodd"}})])
          )
        }
      }
    